import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function J() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('vanlife');
    const items: any[] = [
        {
            title: t('secJ_item1_title'),
            link: t('secJ_item1_link'),
            desc: t('secJ_item1_desc'),
            img: '/responsive/picture/vanlife/9_1.jpg',
            tables: [
                { key: 1, value: t('secJ_item1_table_content1') },
                { key: 2, value: t('secJ_item1_table_content2') },
                { key: 3, value: t('secJ_item1_table_content3') },
                { key: 4, value: t('secJ_item1_table_content4') },
                { key: 5, value: t('secJ_item1_table_content5') },
                { key: 6, value: t('secJ_item1_table_content6') },
                { key: 7, value: t('secJ_item1_table_content7') },
                { key: 8, value: t('secJ_item1_table_content8') },
                { key: 9, value: t('secJ_item1_table_content9') },
                { key: 10, value: t('secJ_item1_table_content10') },
                { key: 11, value: t('secJ_item1_table_content11') },
                { key: 12, value: t('secJ_item1_table_content12') },
                { key: 13, value: t('secJ_item1_table_content13') },
                { key: 14, value: t('secJ_item1_table_content14') },
                { key: 15, value: t('secJ_item1_table_content15') },
                { key: 16, value: t('secJ_item1_table_content16') },
            ],
        },
        {
            title: t('secJ_item2_title'),
            link: t('secJ_item2_link'),
            desc: t('secJ_item2_desc'),
            img: '/responsive/picture/vanlife/9_2.jpg',
            tables: [
                { key: 1, value: t('secJ_item2_table_content1') },
                { key: 2, value: t('secJ_item2_table_content2') },
                { key: 3, value: t('secJ_item2_table_content3') },
                { key: 4, value: t('secJ_item2_table_content4') },
                { key: 5, value: t('secJ_item2_table_content5') },
                { key: 6, value: t('secJ_item2_table_content6') },
                { key: 7, value: t('secJ_item2_table_content7') },
                { key: 8, value: t('secJ_item2_table_content8') },
                { key: 9, value: t('secJ_item2_table_content9') },
                { key: 10, value: t('secJ_item2_table_content10') },
                { key: 11, value: t('secJ_item2_table_content11') },
                { key: 12, value: t('secJ_item2_table_content12') },
                { key: 13, value: t('secJ_item2_table_content13') },
                { key: 14, value: t('secJ_item2_table_content14') },
                { key: 15, value: t('secJ_item2_table_content15') },
                { key: 16, value: t('secJ_item2_table_content16') },
            ],
        },
        {
            title: t('secJ_item3_title'),
            link: t('secJ_item3_link'),
            desc: t('secJ_item3_desc'),
            img: '/responsive/picture/vanlife/9_3.jpg',
            tables: [
                { key: 1, value: t('secJ_item3_table_content1') },
                { key: 2, value: t('secJ_item3_table_content2') },
                { key: 3, value: t('secJ_item3_table_content3') },
                { key: 4, value: t('secJ_item3_table_content4') },
                { key: 5, value: t('secJ_item3_table_content5') },
                { key: 6, value: t('secJ_item3_table_content6') },
                { key: 7, value: t('secJ_item3_table_content7') },
                { key: 8, value: t('secJ_item3_table_content8') },
                { key: 9, value: t('secJ_item3_table_content9') },
                { key: 10, value: t('secJ_item3_table_content10') },
                { key: 11, value: t('secJ_item3_table_content11') },
                { key: 12, value: t('secJ_item3_table_content12') },
                { key: 13, value: t('secJ_item3_table_content13') },
                { key: 14, value: t('secJ_item3_table_content14') },
                { key: 15, value: t('secJ_item3_table_content15') },
                { key: 16, value: t('secJ_item3_table_content16') },
            ],
        },
        {
            title: t('secJ_item4_title'),
            link: t('secJ_item4_link'),
            desc: t('secJ_item4_desc'),
            img: '/responsive/picture/vanlife/9_4.jpg',
            tables: [
                { key: 1, value: t('secJ_item4_table_content1') },
                { key: 2, value: t('secJ_item4_table_content2') },
                { key: 3, value: t('secJ_item4_table_content3') },
                { key: 4, value: t('secJ_item4_table_content4') },
                { key: 5, value: t('secJ_item4_table_content5') },
                { key: 6, value: t('secJ_item4_table_content6') },
                { key: 7, value: t('secJ_item4_table_content7') },
                { key: 8, value: t('secJ_item4_table_content8') },
                { key: 9, value: t('secJ_item4_table_content9') },
                { key: 10, value: t('secJ_item4_table_content10') },
                { key: 11, value: t('secJ_item4_table_content11') },
                { key: 12, value: t('secJ_item4_table_content12') },
                { key: 13, value: t('secJ_item4_table_content13') },
                { key: 14, value: t('secJ_item4_table_content14') },
                { key: 15, value: t('secJ_item4_table_content15') },
                { key: 16, value: t('secJ_item4_table_content16') },
            ],
        },
    ];

    return (
        <div id="vanlife-J" className={`vanlife-J ${css['vanlife-J']}`}>
            <h2 className="title">{t('secJ_title')}</h2>
            <p className="text">{t('secJ_desc')}</p>
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li id={`vanlife-J-${k + 1}`} className="item" key={k}>
                        <h3 className="item-title">{item.title}</h3>
                        <figure className="item-content">
                            <section className="item-media">
                                <div className="item-img">
                                    <EFPicture src={item.img} alt={item.title} />
                                </div>
                                <p className="item-quote">
                                    <span className="quote caption">{t('common_quote')}</span>
                                    <Link href={item.link} className="item-link caption">
                                        {item.link}
                                    </Link>
                                </p>
                            </section>
                            <article className="item-desc text">{item.desc}</article>
                        </figure>
                        {item?.tables && (
                            <table className="item-table" border={1}>
                                <thead className="thead">
                                    <tr className="tr">
                                        <th className="th menu">{t('common_table_project')}</th>
                                        <th className="th">{t('common_table_content')}</th>
                                    </tr>
                                </thead>
                                <tbody className="tbody">
                                    {item?.tables?.map((row: any, m: number) => (
                                        <tr className="tr" key={`valife_J_${k}_${m}`}>
                                            <td className="td menu">{t(`common_table_title${row?.key}`)}</td>
                                            <td className="td">{row?.value}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}
